export const DcqlDesignStyles = {
    pageContainer: "my-5 flex w-full min-w-0 flex-col gap-8",
    instructionBanner:
        "flex items-center gap-3 rounded-xl border border-[#BAE6FD] bg-[#F0F9FF] px-4 py-3 text-sm text-[#0369A1]",
    instructionIcon:
        "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#358CFF] text-xs font-bold text-white",
    sectionBlock: "flex flex-col gap-4",
    sectionHeaderRow: "flex items-start justify-between gap-3",
    sectionHeaderLeft: "flex items-center gap-2",
    sectionEyebrow:
        "text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]",
    sectionTitle: "text-sm font-bold text-[#94A3B8] ",
    satisfiedIcon: "text-[#22C55E]",
    countBadge:
        "flex h-6 w-6 items-center justify-center rounded-full bg-[#7C3AED] text-xs font-semibold text-white",
    statusBadge:
        "inline-flex items-center gap-1 rounded-md border px-3 py-1 text-[12px] font-semibold uppercase tracking-wide font-mono cursor-pointer transition-colors duration-150",
    statusBadgeRequired:
        "border-[#FECACA] bg-[#FEF2F2] text-[#DC2626] hover:border-[#F87171] hover:bg-[#FEE2E2]",
    statusBadgeOptional:
        "border-[#AA913F] bg-[#FFFDDE] text-[#79732D] hover:border-[#927B2E] hover:bg-[#FFF6B8]",
    clearAllButton:
        "text-sm font-semibold text-[#7C1389] border-b border-[#7C1389] transition-colors",
    credentialCardsGrid:
        "grid grid-cols-1 gap-4 sm:grid-cols-2 3xl:grid-cols-3",
    gridContents: "contents",
    credentialOptionFullWidth: "col-span-full",
    credentialCard:
        "relative flex h-full flex-col rounded-2xl border-2 bg-white p-4 shadow-sm transition-colors",
    credentialCardSelected: "border-[#951F6F]",
    credentialCardDefault: "border-[#E2E8F0]",
    credentialCardHeader: "flex items-start justify-between gap-3",
    credentialCardIdentity: "flex min-w-0 flex-1 items-center gap-3",
    credentialLogo:
        "h-12 w-12 shrink-0 rounded-xl border border-[#E2E8F0] bg-white object-cover",
    credentialLogoFallback:
        "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#F1F5F9] text-sm font-bold text-[#475569]",
    credentialName: "truncate text-base font-semibold text-[#0F172A]",
    credentialSubtitle: "truncate text-xs text-[#64748B]",
    actionButton:
        "mt-4 flex w-full items-center justify-between rounded-xl border px-4 py-3 text-sm font-medium transition-colors",
    actionButtonDefault:
        "border-[#E2E8F0] bg-white text-[#0F172A] hover:bg-[#F8FAFC]",
    actionButtonSelected:
        "border-[#121926] bg-[#121926] text-white hover:bg-[#1E293B]",
    actionButtonIcon: "text-[#64748B]",
    actionButtonIconSelected: "text-white",
    multipleCardsContainerDefault:
        "relative rounded-2xl border-2 border-[#E2E8F0] bg-white p-4 shadow-sm",
    multipleCardsContainerSelected:
        "relative rounded-2xl border-2 border-[#951F6F] bg-white p-4 shadow-sm",
    multipleCardsHeaderRow: "mb-4 flex items-start justify-between gap-3",
    multipleCardsTitleRow: "flex items-center gap-2",
    multipleCardsTitle: "text-base font-semibold text-[#6B0F4E]",
    multipleCardsCountBadge:
        "rounded-full bg-[#F8FAFC] px-2.5 py-1.5 border border-[#EAECF0] text-[12px] font-semibold text-[#94A3B8]",
    multipleCardsBody: "grid grid-cols-1 gap-4 md:grid-cols-2",
    multipleCardsInnerCard:
        "flex flex-col rounded-xl border border-[#E2E8F0] bg-white p-3",
    radioOuter:
        "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors",
    radioOuterSelected: "border-none bg-[#951F6F]",
    radioOuterDefault: "border-[#CBD5E1] bg-white",
    radioInner: "h-2.5 w-2.5 rounded-full bg-white",
    showMoreLink:
        "mt-2 text-sm font-medium text-[#358CFF] hover:underline",
};
